import type { AnnotationT } from '../../../image/labelling';
import type { ModernizedGenericAnnotation } from '../types';
export function isAnnotationImported(annotation: ModernizedGenericAnnotation, importedAnnotationIds: string[]) {
  const originalId = annotation.metadata && 'originalId' in annotation.metadata ? ((annotation as unknown) as AnnotationT).metadata?.originalId : undefined;
  return originalId ? importedAnnotationIds.includes(originalId) : false;
}